import { Link, useLocation } from "react-router-dom";
import { Blocks, FileText, Droplets, ArrowLeftRight, ShoppingCart, TrendingDown, Activity, Rocket, Bitcoin, UserCircle, LineChart, Layers, Repeat } from "lucide-react";
import { NAV } from "@/constants/testIds";

export const NAV_LINKS = [
  { to: "/", label: "Explorer", icon: Blocks, testId: NAV.explorerLink },
  { to: "/docs", label: "Docs", icon: FileText, testId: NAV.docsLink },
  { to: "/faucet", label: "Faucet", icon: Droplets, testId: NAV.faucetLink },
  { to: "/swap", label: "Swap", icon: ArrowLeftRight, testId: NAV.swapLink },
  { to: "/buy", label: "Buy", icon: ShoppingCart, testId: NAV.buyLink },
  { to: "/sell", label: "Sell", icon: TrendingDown, testId: NAV.sellLink },
  { to: "/fbtc", label: "FBTC", icon: Bitcoin, testId: "nav-fbtc-link" },
  { to: "/prices", label: "Prices", icon: LineChart, testId: "nav-prices-link" },
  { to: "/liquidity", label: "Pool", icon: Layers, testId: "nav-liquidity-link" },
  { to: "/dex", label: "DEX", icon: Repeat, testId: "nav-dex-link" },
  { to: "/status", label: "Status", icon: Activity, testId: NAV.statusLink },
  { to: "/account", label: "Account", icon: UserCircle, testId: "nav-account-link" },
];

const ACTIVE = "text-[#D4AF37] bg-[#D4AF37]/10";
const IDLE = "text-zinc-400 hover:text-white hover:bg-white/5";

const NavItem = ({ link, active, className, testId, onClick, hideIcon = false }) => {
  const Icon = link.icon;
  return (
    <Link to={link.to} data-testid={testId} onClick={onClick} className={`${className} ${active ? ACTIVE : IDLE}`}>
      <Icon size={16} className={hideIcon ? "hidden" : undefined} />
      {link.label}
    </Link>
  );
};

export const DesktopNav = () => {
  const { pathname } = useLocation();
  return (
    <nav className="hidden md:flex items-center gap-0.5">
      {NAV_LINKS.map((link) => (
        <NavItem key={link.to} link={link} active={pathname === link.to} testId={link.testId} hideIcon
          className="flex items-center gap-1.5 px-2 xl:px-2.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors" />
      ))}
    </nav>
  );
};

export const MobileNav = ({ onClose }) => {
  const { pathname } = useLocation();
  return (
    <nav className="md:hidden pb-4 pt-2 border-t border-white/5 space-y-1">
      {NAV_LINKS.map((link) => (
        <NavItem key={link.to} link={link} active={pathname === link.to} testId={`mobile-${link.testId}`} onClick={onClose}
          className="flex items-center gap-2 px-3 py-2.5 rounded-md text-sm font-medium" />
      ))}
      <Link to="/get-started" data-testid="mobile-nav-get-started-link" onClick={onClose}
        className="flex items-center gap-2 px-3 py-2.5 rounded-md text-sm font-semibold text-[#D4AF37] hover:bg-[#D4AF37]/10">
        <Rocket size={16} /> Get started
      </Link>
    </nav>
  );
};
